module.exports = __webpack_public_path__ + "static/media/49.06bedc70.jpg";